module.exports = __webpack_public_path__ + "img/Vector_nav_ok.6ae082b5.svg";